import { big } from 'src/common/utils/big-utils'
import { BigSource } from 'big.js'

export const getFee = () => {
  const staticFeeAmount = big('2500000000000000000000000')
  const bps = big('1000000000000000000000000000')
  return staticFeeAmount.div(bps)
}

export const getFeeAmount = (amount: BigSource) => {
  const fee = getFee()
  return big(amount).mul(fee)
}
